import { Component } from 'react';

import { Col } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';

import { ContentCard } from '../../components/ContentCard';
import { ContentWrapper } from '../../components/ContentWrapper';
import { Divider } from '../../components/Divider';

class Docs extends Component {
  public override render() {
    return (
      <ContentWrapper>
        <ContentCard title="API Documentation">
          <Text as="p" className="text-body-md">
            Please see our in-depth documentation on how to use the Opendoor API.
          </Text>
          <Col className="pt-1">
            <a target="_blank" href="https://docs.opendoor.com" rel="noopener noreferrer">
              <strong>Open API Docs →</strong>
            </a>
          </Col>
          <Col className="pt-6">
            <Divider />
          </Col>
          <Col className="pt-6">
            <Text as="h4" className="text-subheader-xs pb-1">
              Questions?
            </Text>
            <Text as="p" className="text-body-md">
              If you have any questions or issues using the API or suggestions for improvements,
              please reach out to us at <a href="mailto:api@opendoor.com">api@opendoor.com</a>
            </Text>
          </Col>
        </ContentCard>
      </ContentWrapper>
    );
  }
}

export default Docs;
